import UserUtils from "src/utils/UserUtils";
import { cn } from "@/libs/utils";

const UserIcon = ({ id, className }: { id: string; className?: string }) => {
  const background = UserUtils.getUserColor(id);

  return (
    <div
      className={cn(
        "flex min-h-9 min-w-9 items-center justify-center rounded-full text-sm font-400 capitalize text-white laptop:min-h-10 laptop:min-w-10 laptop:text-base",
        className,
      )}
      style={{ background }}
    >
      {id?.[0] ?? ""}
    </div>
  );
};

export default UserIcon;
